import React from 'react';
import {connect} from "react-redux";
import {Button, Card, Col, Form, Input, Row, Typography} from "antd";
import language from "../../languages/language";
import TitleAndInfo from "../TitleAndInfo/TitleAndInfo";
import getOrders from "../../actions/getOrders";
import isLoggedIn from "../../actions/isLoggedIn";

class AdvisorID extends React.Component
{
    componentDidMount()
    {
        this.props.isLoggedIn();
    }

    getOrders=(formValues)=>
    {
        this.props.getOrders({...this.props.info,...formValues});
    };

    render()
    {
        const span=8;
        return <Card title={language[this.props.language].advSentToMenu} bordered={false}>
            <TitleAndInfo info={language[this.props.language].advTitleIDLabel}/>
            <Form ref={this.formRef} onFinish={this.getOrders} className={'regularForm'}>
                <Row justify={'center'}>
                    <Typography>{language[this.props.language].advIDLabel}</Typography>
                </Row>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item name="cedula"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input autoComplete={'cedula'} size={'large'} className={'mb-10'} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item className={'text-center'}>
                            <Button type="primary light-blue rounded" htmlType="submit">
                                {language[this.props.language].advButtonIDLabel}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>;
    }
}
function mapStateToProps(state) {
    return {
        language: state.auth.language,
        info:state.info
    }
}
export default connect(mapStateToProps, {getOrders,isLoggedIn})(AdvisorID);